module.exports = __webpack_public_path__ + "img/ios-qr-scanner.dee768e1.svg";